import { getModifierTagId, getSpecialTagId, getDiscountReasonId, getCourseId, getOrderSeatTagId, getOpenItemTypeId } from './chunk-GHIPCFZD.mjs';
import { getSettingsGenericError } from './chunk-TDNRUBPG.mjs';
import { dateSliderHasErrorValue } from './chunk-ZYRHAISW.mjs';
import { getHourMsCore } from './chunk-PHOCK55S.mjs';
import { i18n_config_default } from './chunk-SGCJ7UYI.mjs';
import mapValues from 'lodash/mapValues';
import * as yup from 'yup';

var getDefaultMenuTypeTimeId = (weekDay, key, field) => {
  return `timeBasedMenuType-${weekDay}-${key}-${field}`;
};
var getModifierTagError = (key, field) => {
  const objectKey = getModifierTagId(key, field);
  return getSettingsGenericError({
    key: objectKey,
    id: "registerModeModifierTags",
    message: i18n_config_default.t(
      "settingsModule.registerModeSettings.errors.modifierTags.name"
    ),
    section: "tags" /* TAGS */
  });
};
var getSpecialTagError = (key, field) => {
  const objectKey = getSpecialTagId(key, field);
  return getSettingsGenericError({
    key: objectKey,
    id: "registerModeSpecialTags",
    message: i18n_config_default.t(
      "settingsModule.registerModeSettings.errors.specialTags.name"
    ),
    section: "tags" /* TAGS */
  });
};
var getDiscountReasonError = (key, field) => {
  const objectKey = getDiscountReasonId(key, field);
  return getSettingsGenericError({
    key: objectKey,
    id: "registerModeDiscountReasons",
    message: i18n_config_default.t(
      "settingsModule.registerModeSettings.errors.discountReasons.name"
    ),
    section: "tags" /* TAGS */
  });
};
var getCourseError = (key, field) => {
  const objectKey = getCourseId(key, field);
  return getSettingsGenericError({
    key: objectKey,
    id: "registerModeCourses",
    message: i18n_config_default.t("settingsModule.registerModeSettings.errors.courses.name"),
    section: "tableService" /* TABLE_SERVICE */
  });
};
var getOrderSeatTagError = (key, field) => {
  const objectKey = getOrderSeatTagId(key, field);
  return getSettingsGenericError({
    key: objectKey,
    id: "registerModeOrderSeatTags",
    message: i18n_config_default.t(
      "settingsModule.registerModeSettings.errors.orderSeatTags.name"
    ),
    section: "tags" /* TAGS */
  });
};
var getOpenItemTypeError = (key, field) => {
  const objectKey = getOpenItemTypeId(key, field);
  return getSettingsGenericError({
    key: objectKey,
    id: "registerModeOpenItemTypes",
    message: i18n_config_default.t(
      "settingsModule.registerModeSettings.errors.openItemTypes.name"
    ),
    section: "tags" /* TAGS */
  });
};
var registerModeOpenItemTypesSchema = yup.lazy(
  (obj) => yup.object(
    mapValues(
      obj,
      (_, key) => yup.object({
        name: yup.string().trim().required(JSON.stringify(getOpenItemTypeError(key, "name"))),
        posName: yup.string().nullable().trim().required(JSON.stringify(getOpenItemTypeError(key, "posName")))
      })
    )
  )
);
var registerModeSpecialTagsSchema = yup.lazy(
  (obj) => yup.object(
    mapValues(
      obj,
      (_, key) => yup.object({
        name: yup.string().trim().required(JSON.stringify(getSpecialTagError(key, "name"))),
        abbreviation: yup.string().nullable().trim().required(JSON.stringify(getSpecialTagError(key, "abbreviation"))),
        posName: yup.string().nullable().trim().required(JSON.stringify(getSpecialTagError(key, "posName")))
      })
    )
  )
);
var registerModeOrderSeatTagsSchema = yup.lazy(
  (obj) => yup.object(
    mapValues(
      obj,
      (_, key) => yup.object({
        name: yup.string().trim().required(JSON.stringify(getOrderSeatTagError(key, "name"))),
        posName: yup.string().trim().required(JSON.stringify(getOrderSeatTagError(key, "posName"))),
        type: yup.string().nullable().trim().required(JSON.stringify(getOrderSeatTagError(key, "type"))),
        isOrderTag: yup.boolean().test("isOrderTag-isSeatTag-test", function() {
          const orderSeatTag = this.parent;
          const typedOrderSeatTag = orderSeatTag;
          if (!typedOrderSeatTag.isOrderTag && !typedOrderSeatTag.isSeatTag) {
            return this.createError({
              message: JSON.stringify(
                getOrderSeatTagError(key, "orderOrSeatTag")
              )
            });
          }
          return true;
        })
      })
    )
  )
);
var registerModeDiscountReasonsSchema = yup.lazy(
  (obj) => yup.object(
    mapValues(
      obj,
      (_, key) => yup.object({
        name: yup.string().trim().required(JSON.stringify(getDiscountReasonError(key, "name"))),
        posName: yup.string().trim().required(JSON.stringify(getDiscountReasonError(key, "posName")))
      })
    )
  )
);
var registerModeModifierTagsSchema = yup.lazy(
  (obj) => yup.object(
    mapValues(
      obj,
      (_, key) => yup.object({
        name: yup.string().trim().required(JSON.stringify(getModifierTagError(key, "name"))),
        posName: yup.string().trim().required(JSON.stringify(getModifierTagError(key, "posName")))
      })
    )
  )
);
var registerModeAdsSchema = yup.lazy(
  (obj) => yup.object(
    mapValues(
      obj,
      () => yup.object({
        name: yup.string().trim().optional()
      })
    )
  )
);
var settingsSchema = (message, timeZone) => yup.lazy(
  (obj) => yup.object(
    mapValues(obj, (_, weekDay) => {
      return yup.lazy((rules) => {
        return yup.array().of(
          yup.object().test("time-validation", "", function(rule) {
            const typedRule = rule;
            const index = Number(this.path.split("[")[1].split("]")[0]);
            const bannedRanges = rules.slice(0, index).map((value) => [
              getHourMsCore(value.startTime, timeZone),
              getHourMsCore(value.endTime, timeZone)
            ]);
            const hasError = dateSliderHasErrorValue(
              [
                getHourMsCore(typedRule.startTime, timeZone),
                getHourMsCore(typedRule.endTime, timeZone)
              ],
              bannedRanges
            );
            if (hasError) {
              return this.createError({
                message: message(weekDay, typedRule.id)
              });
            }
            return true;
          })
        );
      });
    })
  )
);
var registerModeCoursesSchema = yup.lazy(
  (obj) => yup.object(
    mapValues(
      obj,
      (_, key) => yup.object({
        name: yup.string().trim().required(JSON.stringify(getCourseError(key, "name"))),
        posName: yup.string().trim().required(JSON.stringify(getCourseError(key, "posName"))),
        kitchenName: yup.string().trim().required(JSON.stringify(getCourseError(key, "kitchenName")))
      })
    )
  )
);
var registerModeSchema = (timeZone) => yup.object().shape({
  modifierTags: registerModeModifierTagsSchema,
  ads: registerModeAdsSchema,
  specialTags: registerModeSpecialTagsSchema,
  openItemTypes: registerModeOpenItemTypesSchema,
  orderSeatTags: registerModeOrderSeatTagsSchema,
  discountReasons: registerModeDiscountReasonsSchema,
  courses: registerModeCoursesSchema,
  defaultMenuTypeTimes: settingsSchema(
    (weekDay, id) => JSON.stringify({
      [getDefaultMenuTypeTimeId(weekDay, id, "time")]: {
        id: "timeBasedMenuType" /* TIME_BASED_MENU_TYPE */,
        data: {
          ruleId: id,
          day: weekDay
        },
        kind: {
          id: "registerModeDefaultMenuTypeTimes",
          data: {
            message: i18n_config_default.t(
              "settingsModule.registerModeSettings.errors.defaultMenuTypeTimes.time"
            )
          },
          type: "genericError" /* GENERIC_ERROR */,
          section: "general" /* GENERAL */
        }
      }
    }),
    timeZone
  )
});

export { getDefaultMenuTypeTimeId, registerModeAdsSchema, registerModeCoursesSchema, registerModeDiscountReasonsSchema, registerModeModifierTagsSchema, registerModeOpenItemTypesSchema, registerModeOrderSeatTagsSchema, registerModeSchema, registerModeSpecialTagsSchema, settingsSchema };
